import { randomId } from '@shared/utils/randomId.js';
import IconV2 from '@/components/v2/IconV2.jsx';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2.jsx';
import Spinner from '@/components/Spinner.jsx';
import { HiMiniEllipsisHorizontal } from '@/components/react-icons/main';
import TableCell from './TableCell.jsx';

// `actionButtons` names the actions drawn as icon buttons in the row; the rest stay in the menu.
const TableRow = ({ data, columns, actions = [], actionButtons = [], actionMenuFitContent = false, hasActions = false, onChange, onAction, onRowClick, select }) => {
  const id = randomId();
  const isActionLoading = actions.some((action) => action.loading);
  const buttons = actions.filter((action) => actionButtons.includes(action.value));
  const menu = actions.filter((action) => !actionButtons.includes(action.value));

  return (
    <div className={`table-row ${onRowClick ? 'table-row-highlight' : ''}`} onClick={(event) => onRowClick?.(data, event)}>
      {columns
        .filter((c) => !!c?.width)
        .map((column, index) => (
          <TableCell key={index} column={column} value={data[column.key]} style={{ ...column.style, width: column.width }} onChange={(e) => onChange(column, data, e)} select={select} />
        ))}
      {hasActions && (
        <div className={`table-cell actions-cell ${buttons.length ? 'has-buttons' : ''}`}>
          {buttons.map((action) => (
            <IconV2
              key={action.value}
              icon={action.loading ? Spinner : action.icon}
              title={action.title || action.label}
              className={`light-medium actions-button ${isActionLoading ? 'loading' : ''}`}
              onClick={(event) => {
                event.stopPropagation();
                if (!isActionLoading) {
                  onAction(data, action);
                }
              }}
            />
          ))}
          {menu.length > 0 && (
            <>
              <IconV2 icon={isActionLoading && !buttons.length ? Spinner : HiMiniEllipsisHorizontal} className={`light-medium actions-button ${isActionLoading ? 'loading' : ''} ${id}`} />
              {!isActionLoading && <FloatingSelectV2 className={actionMenuFitContent ? 'fit-content' : ''} triggers={[`.${id}`]} options={menu} onChange={(e) => onAction(data, e)} useSearch={false} smartWidth={actionMenuFitContent} virtualize={actionMenuFitContent ? false : undefined} />}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TableRow;
